import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

import { CustomModal } from "../../../../components/CustomModal";
import { DownloadIcon } from "../../../../components/icons";
import { useExportRequests } from "../../../../hooks/reactQueryHooks/useRequests";
import { downloadCSV } from "../../../../utils/downloadCSV";

interface ShieldExportProps {
  organization: string;
}

const ShieldExport: React.FC<ShieldExportProps> = ({ organization }) => {
  const [show, setShow] = useState(false);
  const { refetch, isSuccess, data, isFetching, isLoading } =
    useExportRequests(organization);

  const toggleModal = () => {
    setShow(!show);
  };

  const handleExportCsv = async () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    refetch();
  };

  useEffect(() => {
    if (isSuccess) {
      downloadCSV(data, "requests");
      setShow(false);
      toast.success("File exported successfully");
    }
  }, [isSuccess, data]);

  const footerButtons = () => {
    return (
      <>
        <Button
          className="btn btn-secondary btn-sm"
          size="sm"
          variant="secondary"
          onClick={toggleModal}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          className="btn btn-primary"
          disabled={false}
          type="submit"
          onClick={handleExportCsv}
        >
          Export
          {(isFetching || isLoading) && (
            <Spinner className="ms-2" size="sm" animation="border" />
          )}
        </Button>
      </>
    );
  };

  return (
    <>
      <Button
        className="fw-bold flex-shrink-0 d-flex align-items-center gap column-gap-2"
        onClick={toggleModal}
      >
        <DownloadIcon />
        Export
      </Button>

      {show && (
        <CustomModal
          show={true}
          handleClose={toggleModal}
          title="Export cache items"
          footer={footerButtons()}
        >
          <div>
            <p className="m-0">Export a CSV file with requests.</p>
            <div className="mt-7" />
            <p className="m-0">
              Exporting by CSV is limited to 1000 requests due to the huge
              amount of data. For larger exports, please use our{" "}
              <a href="/" target="_blank" rel=" noopener noreferrer">
                API
              </a>
              .
            </p>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export { ShieldExport };
